<template>
  <el-drawer
    v-model="visible"
    class="mobile-system-dialog"
    :title="current.title"
    direction="btt"
    size="auto"
    :close-on-click-modal="current.options.closeOnClickModal !== false"
    :close-on-press-escape="current.options.closeOnPressEscape !== false"
    :show-close="current.options.showClose !== false"
    :before-close="handleBeforeClose"
    destroy-on-close
    @closed="handleClosed"
  >
    <div class="mobile-system-dialog__content">
      <p v-if="current.options.dangerouslyUseHTMLString" class="mobile-system-dialog__message" v-html="current.message" />
      <p v-else class="mobile-system-dialog__message">{{ current.message }}</p>
      <el-input
        v-if="current.kind === 'prompt'"
        v-model="inputValue"
        class="mobile-system-dialog__input"
        :placeholder="current.options.inputPlaceholder || ''"
        :maxlength="current.options.inputMaxlength"
        :show-word-limit="Boolean(current.options.showWordLimit)"
        autofocus
        @keyup.enter="submit"
      />
      <p v-if="validationMessage" class="mobile-system-dialog__validation">{{ validationMessage }}</p>
    </div>
    <template #footer>
      <div class="mobile-system-dialog__footer">
        <el-button v-if="current.kind !== 'alert' && current.options.showCancelButton !== false" @click="cancel">
          {{ current.options.cancelButtonText || '取消' }}
        </el-button>
        <el-button type="primary" :loading="submitting" @click="submit">
          {{ current.options.confirmButtonText || '确定' }}
        </el-button>
      </div>
    </template>
  </el-drawer>
</template>

<script>
import { subscribeResponsiveDialog } from '@/utils/responsiveSystemDialog'

export default {
  name: 'ResponsiveSystemDialog',
  data() {
    return {
      visible: false,
      current: { options: {} },
      inputValue: '',
      validationMessage: '',
      submitting: false,
      unsubscribe: null
    }
  },
  mounted() {
    this.unsubscribe = subscribeResponsiveDialog(payload => {
      if (this.visible) this.finish('cancel')
      this.current = payload
      this.inputValue = payload.options.inputValue || ''
      this.validationMessage = ''
      this.submitting = false
      this.visible = true
    })
  },
  beforeUnmount() {
    this.unsubscribe?.()
    this.unsubscribe = null
    if (this.visible) this.finish('cancel')
  },
  methods: {
    validate(value) {
      const validator = this.current.options.inputValidator
      const pattern = this.current.options.inputPattern
      if (pattern && !pattern.test(String(value || ''))) {
        this.validationMessage = this.current.options.inputErrorMessage || '输入内容不符合要求'
        return false
      }
      if (!validator) return true
      const result = validator(value)
      if (result === true || result === undefined) {
        this.validationMessage = ''
        return true
      }
      this.validationMessage = String(result)
      return false
    },
    submit() {
      if (this.submitting) return
      if (this.current.kind === 'prompt' && !this.validate(this.inputValue)) return
      this.submitting = true
      const beforeClose = this.current.options.beforeClose
      if (typeof beforeClose === 'function') {
        const instance = { confirmButtonLoading: true, confirmButtonText: this.current.options.confirmButtonText, showCancelButton: this.current.options.showCancelButton !== false }
        let closed = false
        const done = () => { if (!closed) { closed = true; this.current.resolve(this.current.kind === 'prompt' ? { value: this.inputValue } : undefined); this.visible = false } }
        const result = beforeClose('confirm', instance, done)
        if (result && typeof result.then === 'function') result.then(done).catch(() => { this.submitting = false })
        return
      }
      const payload = this.current.kind === 'prompt' ? { value: this.inputValue } : undefined
      this.current.resolve(payload)
      this.visible = false
    },
    cancel() {
      this.finish('cancel')
    },
    handleBeforeClose(done) {
      this.current.reject('close')
      done()
    },
    handleClosed() {
      this.submitting = false
    },
    finish(reason) {
      if (!this.visible && !this.current?.resolve) return
      this.current.reject(reason)
      this.visible = false
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/css/variables';

.el-drawer.mobile-system-dialog {
  width: 100% !important;
  max-height: min(92dvh, 620px);
  border-radius: 16px 16px 0 0;
  background: var(--agst-bg-card, $bg-card);
  color: var(--agst-text-color-primary, $text-color-primary);
  overflow: hidden;

  .el-drawer__header {
    flex-shrink: 0;
    margin: 0;
    padding: 14px 56px 12px 16px;
    border-bottom: 1px solid var(--agst-border-color, $border-color);
  }

  .el-drawer__title {
    font-size: 18px;
    line-height: 1.4;
    overflow-wrap: anywhere;
  }

  .el-drawer__body {
    flex: 1 1 auto;
    min-height: 0;
    padding: 16px;
    overflow-y: auto;
    overscroll-behavior: contain;
  }

  .el-drawer__footer {
    flex-shrink: 0;
    padding: 12px 16px calc(12px + env(safe-area-inset-bottom));
    border-top: 1px solid var(--agst-border-color, $border-color);
  }
}

.mobile-system-dialog__message {
  margin: 0;
  color: inherit;
  font-size: 16px;
  line-height: 1.6;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.mobile-system-dialog__input {
  margin-top: 14px;
  .el-input__wrapper { min-height: 44px; }
  .el-input__inner { font-size: 16px; }
}

.mobile-system-dialog__validation {
  margin: 6px 0 0;
  color: var(--el-color-danger);
  font-size: 13px;
  line-height: 1.4;
}

.mobile-system-dialog__footer {
  display: flex;
  gap: 10px;
  .el-button {
    flex: 1 1 0;
    min-width: 44px;
    min-height: 44px;
    margin: 0;
    white-space: normal;
    overflow-wrap: anywhere;
  }
}
</style>
